// 后端地址统一从 Vite 环境变量读取（构建时注入 import.meta.env）
//
//   VITE_API_BASE_URL  API 基础地址，如 http://127.0.0.1:3000（默认值见 .env / .env.example）
//   VITE_WS_URL        WebSocket 基础地址，如 ws://127.0.0.1:3000
//                      未配置时由 VITE_API_BASE_URL 自动派生（http -> ws，https -> wss）
//
// 注意：这里不再写死任何 IP / 域名 / 端口，切换部署环境只需改 .env。

// 去掉末尾斜杠，避免后续拼接出现双斜杠
export const apiBase = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '')

// 把后端返回的相对资源路径（如 /static/...、/uploads/...）拼成可访问的绝对 URL。
// 空值返回空串；已是 http(s) 绝对地址则原样返回；否则补全前导斜杠后拼接 apiBase。
export function absUrl(u) {
  if (!u) return ''
  if (/^https?:\/\//i.test(u)) return u
  return apiBase + (u.startsWith('/') ? u : '/' + u)
}

// WebSocket 基础地址：优先使用显式配置的 VITE_WS_URL，否则由 apiBase 派生。
export const wsBase = (() => {
  const explicit = (import.meta.env.VITE_WS_URL || '').replace(/\/+$/, '')
  if (explicit) return explicit
  return apiBase.replace(/^http/i, 'ws')
})()
